import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { baseURL2 } from '../helper/helper'

export default function Donation() {
    const { donation_info, madarsa, loading } = useSelector((state) => state.reducer || {})
    const [copied, setCopied] = useState('');

    const handleCopy = (text, field) => {
        navigator.clipboard.writeText(text);
        setCopied(field);
        setTimeout(() => setCopied(''), 2000);
    };

    if (loading && !madarsa) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white text-secondary text-sm tracking-widest uppercase font-semibold animate-pulse">
                Loading Gateway...
            </div>
        )
    }

    return (
        <main className="min-h-screen bg-white text-gray-900 pb-24">
            <section className="pt-32 pb-16 px-6 max-w-4xl mx-auto text-center">
                <span className="text-xs tracking-widest uppercase text-secondary mb-6 block font-semibold">Secure Philanthropy</span>
                <h1 className="text-4xl md:text-6xl font-light text-primary tracking-tight leading-tight mb-8">
                    Fuel Our <span className="font-medium text-secondary">Vision</span>.
                </h1>
                <p className="text-lg md:text-xl text-gray-500 font-light max-w-2xl mx-auto leading-relaxed">
                    {donation_info?.message || "Join us in shaping the future of seekers through your generous contributions to education and humanity."}
                </p>
            </section>

            <section className="py-16 px-6 md:px-12 max-w-5xl mx-auto border-t border-gray-100">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-start">
                    {/* Bank Details */}
                    <div>
                        <h3 className="text-2xl font-light mb-8 text-primary">Bank Transfer</h3>
                        {donation_info ? (
                            <div className="space-y-4">
                                <div className="p-6 bg-primary/5 rounded-2xl border border-primary/10 flex justify-between items-center text-sm">
                                    <div>
                                        <span className="block text-secondary mb-1 text-[10px] uppercase tracking-widest font-bold">Beneficiary Name</span>
                                        <span className="font-medium text-primary">{donation_info.account_holder_name}</span>
                                    </div>
                                    <button onClick={() => handleCopy(donation_info.account_holder_name, 'name')} className="text-primary/50 hover:text-primary transition-colors">Copy</button>
                                </div>
                                <div className="p-6 bg-primary/5 rounded-2xl border border-primary/10 flex justify-between items-center text-sm">
                                    <div>
                                        <span className="block text-secondary mb-1 text-[10px] uppercase tracking-widest font-bold">Bank Name</span>
                                        <span className="font-medium text-primary">{donation_info.bank_name}</span>
                                    </div>
                                    <button onClick={() => handleCopy(donation_info.bank_name, 'bank')} className="text-primary/50 hover:text-primary transition-colors">Copy</button>
                                </div>
                                <div className="p-6 bg-primary text-white rounded-2xl shadow-lg border border-primary-light flex justify-between items-center text-sm">
                                    <div>
                                        <span className="block text-secondary mb-1 text-[10px] uppercase tracking-widest font-bold">Account Number</span>
                                        <span className="font-mono text-xl">{donation_info.bank_account_number}</span>
                                    </div>
                                    <button onClick={() => handleCopy(donation_info.bank_account_number, 'account')} className="text-white/50 hover:text-white transition-colors">Copy</button>
                                </div>
                                <div className="p-6 bg-primary/5 rounded-2xl border border-primary/10 flex justify-between items-center text-sm">
                                    <div>
                                        <span className="block text-secondary mb-1 text-[10px] uppercase tracking-widest font-bold">IFSC Code</span>
                                        <span className="font-mono text-primary font-bold">{donation_info.ifsc_code}</span>
                                    </div>
                                    <button onClick={() => handleCopy(donation_info.ifsc_code, 'ifsc')} className="text-primary/50 hover:text-primary transition-colors">Copy</button>
                                </div>
                                {copied && <div className="text-xs text-green-600 font-semibold text-center mt-4">Copied to clipboard!</div>}
                            </div>
                        ) : (
                            <div className="p-12 text-center text-gray-400 text-sm bg-gray-50 border border-gray-100 rounded-2xl">
                                Current details unavailable.
                            </div>
                        )}
                    </div>

                    {/* QR Code */}
                    <div>
                        <h3 className="text-2xl font-light mb-8 text-primary">UPI Payment</h3>
                        <div className="bg-primary/5 border border-primary/10 p-8 flex flex-col items-center justify-center min-h-[360px] rounded-[40px]">
                            {donation_info?.qr_code_image ? (
                                <img src={baseURL2 + donation_info.qr_code_image} alt="UPI QR" className="w-56 h-56 object-contain mb-8 mix-blend-multiply" />
                            ) : (
                                <div className="w-56 h-56 border border-dashed border-gray-300 flex items-center justify-center mb-8 text-gray-400 text-sm">
                                    No QR Code
                                </div>
                            )}
                            <div className="flex items-center gap-4 text-sm bg-white p-3 rounded-xl border border-gray-100 shadow-sm w-full max-w-xs justify-between">
                                <span className="font-mono font-medium text-primary ml-2 truncate">{donation_info?.upi_id || "madarsa@upi"}</span>
                                <button onClick={() => handleCopy(donation_info?.upi_id || "", 'upi')} className="text-secondary hover:text-secondary-light uppercase text-xs font-bold tracking-widest pl-4 border-l border-gray-100 transition-colors">
                                    Copy
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}
